import type { PersistenceLevel } from '@/core/flux.service';
import { Store } from '@/core/flux.service';
import type { AnyProperty } from '@/utilities.types';

export class VantageTrendStore extends Store {
  persistenceLevel: PersistenceLevel = 'WORKSHEET';
  static readonly storeName = 'sqVantageTrendStore';

  initialize(): void {
    this.state = this.immutable({
      quickTrendOpen: false,
      isSingleAxis: true,
    });
  }

  get quickTrendOpen(): boolean {
    return this.state.get('quickTrendOpen');
  }

  get isSingleAxis(): boolean {
    return this.state.get('isSingleAxis');
  }

  dehydrate() {
    return this.state.serialize();
  }

  rehydrate(dehydratedState: AnyProperty) {
    this.state.merge(dehydratedState);
  }

  protected readonly handlers = {
    SET_VANTAGE_QUICK_TREND_OPEN: (payload: { isOpen: boolean }) => this.state.set('quickTrendOpen', payload.isOpen),
    SET_VANTAGE_TREND_SINGLE_AXIS: (payload: { isSingleAxis: boolean }) =>
      this.state.set('isSingleAxis', payload.isSingleAxis),
  };
}
